import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Collapse, Paper, Typography } from '@mui/material';
import classnames from 'classnames';

import AdminSupplementStatusCount from '@components/AdminSupplementStatusCount/AdminSupplementStatusCount';
import UpDownButton from '@components/UpDownButton/UpDownButton';
import useToggle from '@hooks/useToggle';
import { TAdminSupplementInquiryStatus } from '@interfaces/adminSupplements';

import { ILegendCardProps } from './LegendCard.interface';

import './style.scss';

const LegendCard: FC<ILegendCardProps> = ({ className }) => {
  const { t } = useTranslation();

  const [open, , , handleToggle] = useToggle(true);

  return (
    <Paper className={classnames('legend-card', className)} elevation={0}>
      <Box className="legend-card__header">
        <Typography variant="h6" className="legend-card__title">
          {t('adminInquiries.itemLegend')}
        </Typography>

        <UpDownButton onOpen={handleToggle} open={open} />
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box className="legend-card__body">
          <Box className="legend-card__row">
            <AdminSupplementStatusCount
              value={TAdminSupplementInquiryStatus.New}
              count={1}
              hideLabel
            />
            <div className="legend-card__status">{t('adminInquiries.new')}</div>
            <div className="legend-card__description">
              {t('adminInquiries.legendNewItemDescription')}
            </div>
          </Box>

          <Box className="legend-card__row">
            <AdminSupplementStatusCount
              value={TAdminSupplementInquiryStatus.Other}
              count={2}
              hideLabel
            />
            <div className="legend-card__status">{t('adminInquiries.needsReview')}</div>
            <div className="legend-card__description">
              {t('adminInquiries.legendReviewedItemDescription')}
            </div>
          </Box>

          <Box className="legend-card__row">
            <AdminSupplementStatusCount
              value={TAdminSupplementInquiryStatus.Recent}
              count={3}
              hideLabel
            />
            <div className="legend-card__status">{t('adminInquiries.recentlyRenewed')}</div>
            <div className="legend-card__description">
              {t('adminInquiries.legendRecentlyRenewedItemDescription')}
            </div>
          </Box>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default LegendCard;
